module.exports = __webpack_public_path__ + "assets/img/zhaoqing-4bd80041.png";